import angry01 from "../../../assets/animation/rating_0_1_symbols_angry.json";
import angry23 from "../../../assets/animation/rating_2_3_angry.json";
import frown4 from "../../../assets/animation/rating_4_frown.json";
import neutral5 from "../../../assets/animation/rating_5_neutral.json";
import slightSmile6 from "../../../assets/animation/rating_6_slight_smile.json";
import smiley78 from "../../../assets/animation/rating_7_8_smiley.json";
import heartEyes910 from "../../../assets/animation/rating_10_heart_eyes.json";

// Score (0-10) -> bundled Lottie reaction, grouped the same way the design's
// emoji set is grouped.
export const SCORE_EMOJI_ANIMATION = {
  0: angry01, 1: angry01,
  2: angry23, 3: angry23,
  4: frown4,
  5: neutral5,
  6: slightSmile6,
  7: smiley78, 8: smiley78,
  9: heartEyes910, 10: heartEyes910,
};
